import styled from "styled-components";

import { Modal } from "components/Modal";

export const PurchasePlanModalContainer = styled(Modal)`
  z-index: 1110;

  .modal-dialog {
    z-index: 1110;
  }

  .modal-content {
    padding: 0;
    min-height: 400px;

    .modal-body {
      margin: 0;
      padding: 0px 0;
      overflow: hidden;

      .content-wrapper {
        padding: 30px 40px;
        background-color: ${({ theme }) => theme.modal.bg.quinary};
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;

        a {
          text-decoration: none;
          font-weight: 500;
          font-size: 14px;
          color: ${({ theme }) => theme.button.bg.primary};

          svg {
            margin-left: 5px;
          }
        }

        h2 {
          font-size: 25px;
          margin-bottom: 0;
        }

        p {
          font-size: 13px;
          color: ${({ theme }) => theme.modal.color.primary};
        }

        h4 {
          font-size: 16px;
        }

        ul {
          list-style: none;
          padding-left: 0;

          li {
            font-size: 15px;
            display: flex;
            align-items: baseline;

            svg {
              margin-right: 6px;
            }

            .tag {
              padding: 0 5px;
              border-radius: 8px;
              margin-right: 6px;
              line-height: 1.5rem;
            }
          }
        }
      }

      .trial-details {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 30px 0 40px 0;

        .sub-text {
          font-size: 13px;
          color: ${({ theme }) => theme.modal.color.primary};
        }
      }

      button {
        width: 100%;
        margin-top: 15px;
      }

      .due-date {
        font-weight: 500;
        font-size: 15px;
        color: ${({ theme }) => theme.button.bg.primary};
        margin-top: 85px;
      }

      .helptext {
        font-size: 12px;
        color: ${({ theme }) => theme.modal.color.primary};
        text-align: center;
      }

      .price-wrapper {
        padding: 30px 40px;

        h2 {
          font-size: 15px;
        }

        .monthly-wrapper {
          display: flex;
          align-items: center;
        }

        .yearly-wrapper {
          display: flex;
          align-items: center;

          div {
            padding: 6px 10px;
            font-size: 14px;
            font-weight: 500;
            background-color: ${({ theme }) => theme.button.bg.primary};
          }
        }

        .current-plan-label {
          font-size: 12px;
          margin-left: 10px;
          color: ${({ theme }) => theme.button.bg.primary};
        }

        .form-check {
          margin-bottom: 20px;

          .form-check-input {
            margin-top: 8px;
          }

          .form-check-label {
            font-size: 20px;
            font-weight: 500;

            .price {
              font-size: 15px;
              color: ${({ theme }) => theme.modal.color.primary};
            }
          }
        }
      }

      .current-wrapper {
        padding: 30px 40px;

        .current-plan {
          margin-bottom: 1.5rem;

          h2 {
            text-transform: capitalize;
            font-size: 20px;
            font-weight: 500;
          }
        }

        .details {
          font-size: 13px;
          margin-bottom: 4rem;
        }

        button.cancel-premium-btn {
          background-color: #ff3f3f;
        }
        button.change-premium-btn {
          background-color: transparent;
          text-align: right;
          .loader {
            justify-content: right;
          }
        }
      }

      .pro-plan-label {
        position: absolute;
        bottom: 25px;
      }
    }
  }

  @media (max-width: 768px) {
    .modal-content .modal-body {
      .price-wrapper {
        padding: 30px 40px 50px;

        .trial-details {
          margin-top: 0;

          svg {
            width: 46px;
          }
        }

        .helptext {
          margin-bottom: 20px;
        }
      }

      .pro-plan-label {
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .content-wrapper {
        ul li {
          font-size: 14px;
        }
      }

      .due-date {
        margin-top: 40px;
      }
    }
  }
`;
